import { ReactNode, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Content } from "../_metronic/layout/components/content";
import { FooterWrapper } from "../_metronic/layout/components/footer";
import { PageDataProvider } from "../_metronic/layout/core";
import { reInitMenu } from "../_metronic/helpers";
import { ThemeModeProvider } from "../_metronic/partials/layout/theme-mode/ThemeModeProvider";
import { ToolbarWrapper } from "../_metronic/layout/components/toolbar";
import { LoginModal } from "../modules/auth/components/LoginModal/LoginModal";

interface AppShellLayoutProps {
  nav: ReactNode;
  showToolbar?: boolean;
  showFooter?: boolean;
}

export function AppShellLayout({
  nav,
  showToolbar = true,
  showFooter = true,
}: AppShellLayoutProps) {
  const location = useLocation();

  useEffect(() => {
    reInitMenu();
  }, [location.key]);

  return (
    <PageDataProvider>
      <ThemeModeProvider>
        <div className="d-flex flex-column flex-root app-root" id="kt_app_root">
          <LoginModal />
          <div
            className="app-page flex-column flex-column-fluid"
            id="kt_app_page"
          >
            {nav}

            <div
              className="app-wrapper flex-column flex-row-fluid"
              id="kt_app_wrapper"
            >
              <div
                className="app-main flex-column flex-row-fluid"
                id="kt_app_main"
              >
                <div className="d-flex flex-column flex-column-fluid">
                  {showToolbar && <ToolbarWrapper />}
                  <Content>
                    <Outlet />
                  </Content>
                </div>
                {showFooter && <FooterWrapper />}
              </div>
            </div>
          </div>
        </div>
      </ThemeModeProvider>
    </PageDataProvider>
  );
}
